import { Col, Row } from 'antd';
import JSGantt from 'react-jsgantt';
import moment from 'moment';
import dayjs from 'dayjs';
import Title from 'antd/lib/typography/Title';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Schedule } from '../../modules/schedules';

interface ScheduleChartComponentProps {
  schedules: Schedule[] | null;
  updateSchedule: (
    scheduleId: number,
    data: any,
    shouldUpdateAll: boolean,
  ) => void;
}

const StyledDiv = styled.div`
  /* tr {
    font-size: 13px !important;
    padding: 3px !important;
  }

  td {
    font-size: 13px !important;
    padding: 3px !important;
  }

  td > div {
    font-size: 13px !important;
    padding: 3px !important;
  } */
`;

function ScheduleChartComponent({
  schedules,
  updateSchedule,
}: ScheduleChartComponentProps) {
  const [scheduleList, setScheduleList] = useState<any[]>([]);
  const [editorOptions, setEditorOptions] = useState<any>();
  const [curPosition, setCurPosition] = useState<string>('');

  useEffect(() => {
    if (!schedules) {
      return;
    }

    const colors = [
      'gtaskblue',
      'gtaskred',
      'gtaskgreen',
      'gtaskyellow',
      'gtaskpurple',
      'gtaskpink',
    ];

    const _scheduleList = schedules.map((schedule, index) => {
      return {
        pID: schedule.id,
        // pName: `${schedule.name} (${schedule.gongjong})`,
        pName: schedule.name,
        pStart: dayjs(schedule.startDate)
          .add(1, 'minute')
          .format('YYYY-MM-DD HH:mm'),
        pEnd: dayjs(schedule.finishDate)
          .add(1, 'day')
          .subtract(1, 'minute')
          .format('YYYY-MM-DD HH:mm'),
        pClass: colors[index % colors.length],
        pLink: '',
        pMile: 0,
        pDuration: 1,
        // pRes: 'Brian',
        // pRes: schedule.gongjong,
        pComp: schedule.complete,
        pGroup: schedule.children.length > 0 ? 1 : 0,
        pParent: schedule.parent ? schedule.parent.id : 0,
        pOpen: 1,
        pDepend: schedule.depends.map((depend) => depend.id).join(','),
        pCaption: '',
        pNotes: schedule.description,
      };
    });
    setScheduleList(_scheduleList);

    const _editorOptions = {
      vFormat: 'day',
      vCaptionType: 'Complete', // Set to Show Caption : None,Caption,Resource,Duration,Complete,
      vQuarterColWidth: 36,
      vShowRes: 0,
      vShowPlanStartDate: 0,
      vShowPlanEndDate: 0,
      vEditable: 1,
      vTotalHeight: '1000px',
      // vDateScheduleDisplayFormat: 'day dd month yyyy', // Shown in tool tip box
      // vDayMajorDateDisplayFormat: 'mon yyyy - Week ww', // Set format to display dates in the "Major" header of the "Day" view
      // vWeekMinorDateDisplayFormat: 'dd mon',
      vDateTaskDisplayFormat: 'yyyy/mon/dd day', // Shown in tool tip box
      vDayMajorDateDisplayFormat: 'yyyy 년 mon 월', // Set format to display dates in the "Major" header of the "Day" view
      vWeekMinorDateDisplayFormat: 'mon/dd',
      vLang: 'ko',
      vUseSort: 0,
      vColumnOrder: [
        'vShowRes',
        'vAdditionalHeaders',
        'vShowDur',
        'vShowComp',
        'vShowStartDate',
        'vShowEndDate',
        'vShowPlanStartDate',
        'vShowPlanEndDate',
        'vShowCost',
        'vShowAddEntries',
      ],
      vAdditionalHeaders: {
        // Add data columns to your table
      },
      vEventClickRow: function (e: any) {
        // console.log('vEventClickRow');
        // console.log(e);
      },
      vEvents: {
        // taskname: console.log,
        // res: console.log,
        // dur: console.log,
        // comp: console.log,
        // start: console.log,
        // end: console.log,
        // planstart: console.log,
        // planend: console.log,
        // cost: console.log,
        // afterDraw: () => {
        //   // console.log("after draw listener");
        // },
        afterDraw: () => {
          const element = document.getElementById(curPosition);
          if (element) {
            // element.scrollIntoView({
            //   behavior: 'smooth',
            //   block: 'start',
            //   inline: 'start',
            // });
            // element.scrollIntoView(true);
            // element.scrollIntoView({
            //   behavior: 'auto',
            //   block: 'center',
            //   inline: 'center',
            // });
            // element.scrollIntoView({
            //   behavior: 'instant',
            //   block: 'nearest',
            //   inline: 'nearest',
            // });
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'nearest',
            });
            // element.scrollIntoView();
            // window.scrollBy(element.off)
            // console.log(element.getBoundingClientRect());
            // window.scrollTo({
            //   top: element.getBoundingClientRect().top,
            //   behavior: 'instant',
            // });
            // window.scrollBy(
            //   element.getBoundingClientRect().x,
            //   element.getBoundingClientRect().y,
            // );
            // setCurPosition('');
            // window.scrollTo(1000, 2000);
            // window.scrollTo(
            //   element.getBoundingClientRect().x,
            //   element.getBoundingClientRect().y,
            // );
            // window.scroll(
            //   element.getBoundingClientRect().x,
            //   element.getBoundingClientRect().y,
            // );
            // window.scrollY = element.getBoundingClientRect().y;
            // window.scrollTo(
            //   element.getBoundingClientRect().x,
            //   element.getBoundingClientRect().y,
            // );
          }
        },
      },
      vEventsChange: {
        taskname: (task: any, event: any, cell: any, column: any) => {
          setCurPosition(event.getChildRow().getAttribute('id'));
          const sch = schedules.filter(
            (item) => item.id === event.getDataObject().pID,
          )[0];
          updateSchedule(
            event.getDataObject().pID,
            {
              ...sch,
              name: event.getAllData().pName,
            },
            false,
          );
        },
        comp: (task: any[], event: any, cell: any, column: any) => {
          setCurPosition(event.getChildRow().getAttribute('id'));
          const sch = schedules.filter(
            (item) => item.id === event.getDataObject().pID,
          )[0];
          updateSchedule(
            event.getDataObject().pID,
            {
              ...sch,
              complete: event.getAllData().pComp ? event.getAllData().pComp : 0,
            },
            true,
          );
        },
        start: (task: any, event: any, cell: any, column: any) => {
          setCurPosition(event.getChildRow().getAttribute('id'));
          const sch = schedules.filter(
            (item) => item.id === event.getDataObject().pID,
          )[0];
          updateSchedule(
            event.getDataObject().pID,
            {
              ...sch,
              startDate: moment(event.getAllData().pStart).format('YYYY-MM-DD'),
            },
            false,
          );
        },
        end: (task: any, event: any, cell: any, column: any) => {
          setCurPosition(event.getChildRow().getAttribute('id'));
          // setCurPosition(column.getAttribute('id'));
          const sch = schedules.filter(
            (item) => item.id === event.getDataObject().pID,
          )[0];
          updateSchedule(
            event.getDataObject().pID,
            {
              ...sch,
              finishDate: moment(event.getAllData().pEnd).format('YYYY-MM-DD'),
            },
            false,
          );
        },
      },
      vEventClickCollapse: (e: any) => {
        // console.log(e, 'vEventClickCollapse');
      },
      vTooltipTemplate: (t: any) => {
        // console.log(t);
        // console.log(t.getAllData());
        const startDateFormated = new Date(t.getStart()).toLocaleDateString(
          'ko',
        );
        const endDateFormated = new Date(t.getEnd()).toLocaleDateString('ko');

        return `<div>
          <span class="gTaskLabel">이름:</span
      ><span class="gTaskText">${t.getName()}</span>
      <br>
      <span class="gTaskLabel">{{Lang:pStart}}:</span
      ><span class="gTaskText">${startDateFormated}</span>
      <br>
      <span class="gTaskLabel">{{Lang:pEnd}}:</span
      ><span class="gTaskText">${endDateFormated}</span>
      <br>
      <span class="gTaskLabel">설명:</span>
      <div>
      ${
        t.getAllData().pDataObject.pNotes
          ? t.getAllData().pDataObject.pNotes.replace(/(\n|\r\n)/g, '<br>')
          : ''
      }
      </div>
    </div>`;
      },
    };
    setEditorOptions(_editorOptions);
  }, [schedules, updateSchedule, curPosition]);

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Title level={3}>공정표</Title>
      </Row>
      <Row>
        <Col span={24}>
          <JSGantt data={scheduleList} options={editorOptions} />
        </Col>
      </Row>
    </StyledDiv>
  );
}

export default ScheduleChartComponent;
